// extracted by mini-css-extract-plugin
module.exports = {"last-card":"aed17b9412--last-card--dflBR","desktop":"aed17b9412--desktop--MqCqW","text-content":"aed17b9412--text-content--DSlyb","image":"aed17b9412--image--RaXOK"};